// extracted by mini-css-extract-plugin
export default {"editableSelectLabel":"EditableSelectLabel_editableSelectLabel__39TEY"};